import {ChangeDetectionStrategy, Component, HostBinding} from '@angular/core';

@Component({
  selector : 'div[lm-blankline]', // tslint:disable-line
  template: '<ng-content></ng-content>',
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class LMBlankLineComponent {
  // IF IE set height to match field heights, blank lines in IE do not span multiple columns
  @HostBinding('style.height') height = '1px';
  @HostBinding('class.lm-blankline') lmBlankLineClass = true;
}
